import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import format from 'date-fns/format';

const ModalHistory = (props) => {
    const resolveHistory = () => {
        // Se item já for um array, usa diretamente; caso contrário, converte
        if (Array.isArray(props?.item)) {
            return props.item
        }
        return props?.item === undefined || JSON.stringify(props.item) === '{}' ? [] : Object.values(props.item)
    }

    return (
        <>
            <Modal show={props.show} size="md" aria-labelledby="contained-modal-title-vcenter" centered onHide={() => props.onClose()}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <i className="fa fa-history" /> Histórico de Atendimento
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{width:"530px", height:"330px"}}>
                    <div style={{display:"flex", flexDirection:"column"}}>
                        <div style={{display:"flex", background:"#cacaca", padding:"5px 0px 5px 0px"}}>
                            <div style={{width:"100px", fontWeight:"bold"}}><span>Tipo</span></div>
                            <div style={{width:"125px", fontWeight:"bold"}}><span>Inicio</span></div>
                            <div style={{width:"125px", fontWeight:"bold"}}><span>Fim</span></div>
                            <div style={{width:"75px", fontWeight:"bold"}}><span>Status</span></div>
                        </div>
                        {resolveHistory().map((_item, key) => {
                            console.log('Item do histórico:', _item)
                            
                            // Suporta ambas as estruturas: startDate/endDate (nova) e startdate/enddate (antiga)
                            const startDate = _item.startDate || _item.startdate
                            const endDate = _item.endDate || _item.enddate
                            const isOpened = _item.isOpened !== undefined ? _item.isOpened : _item.isopened
                            
                            // Função para formatar data com validação
                            const formatDate = (date) => {
                                if (!date) return '-'
                                try {
                                    const dateObj = new Date(date)
                                    if (isNaN(dateObj.getTime())) return '-'
                                    return format(dateObj, 'dd/MM/yyyy HH:mm')
                                } catch (e) {
                                    console.error('Erro ao formatar data:', e)
                                    return '-'
                                }
                            }
                            
                            return (
                                <div style={{display:"flex", padding:"5px 0px 5px 0px", background:`${key % 2 !== 0 ? '#f7f8f9' : 'transparent'}`}} key={key}>
                                    <div style={{width:"100px"}}>
                                        <span>
                                            {_item.option === 0 ? 'Viagem' : 
                                             _item.option === 1 ? 'Serviço' : 
                                             _item.option === 2 ? 'Alimentação' : 
                                             _item.option === 3 ? 'APR' :
                                             _item.option === 4 ? 'Outros' : 'Não informado'}
                                        </span>
                                    </div>
                                    <div style={{width:"125px"}}><span>{formatDate(startDate)}</span></div>
                                    <div style={{width:"125px"}}><span>{formatDate(endDate)}</span></div>
                                    <div style={{width:"75px"}}><span className={`badge ${isOpened ? 'badge-warning' : 'badge-success'}`}> {isOpened ? 'Aberto' : 'Encerrado'}</span></div>
                                </div>
                            )
                        })}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


export default ModalHistory;